import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export const Portal = ({ children }: { children: React.ReactNode }) => {
  const portalDomRef = useRef(document.createElement('div'));

  useEffect(() => {
    const root = document.getElementById('modal-root');

    if (root) {
      root.appendChild(portalDomRef.current);
    }

    return () => {
      if (root) {
        root.removeChild(portalDomRef.current);
      }
    };
  }, []);

  return createPortal(children, portalDomRef.current);
};
